export default function AICapabilities() {
  const capabilities = [
    {
      title: 'Natural Language Search',
      description: 'Search using everyday language and get accurate results',
      icon: 'ri-message-3-line'
    },
    {
      title: 'Visual Recognition',
      description: 'Upload images to find similar products instantly',
      icon: 'ri-image-line'
    },
    {
      title: 'Price Optimization',
      description: 'AI-powered dynamic pricing for maximum profitability',
      icon: 'ri-price-tag-3-line'
    },
    {
      title: 'Demand Forecasting',
      description: 'Predict trends and stock inventory intelligently',
      icon: 'ri-bar-chart-box-line'
    },
    {
      title: 'Fraud Detection',
      description: 'Advanced algorithms protect against fraudulent activities',
      icon: 'ri-shield-check-line'
    },
    {
      title: 'Personalization Engine',
      description: 'Tailored experiences for every individual user',
      icon: 'ri-user-heart-line'
    }
  ];

  return (
    <section id="ai-capabilities" className="py-24 bg-gradient-to-br from-indigo-900 via-purple-900 to-indigo-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-purple-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-indigo-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-4">
            <i className="ri-cpu-line text-yellow-400"></i>
            <span className="text-sm font-semibold text-white">AI TECHNOLOGY</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Powered by Advanced Artificial Intelligence
          </h2>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Our platform leverages state-of-the-art machine learning models to deliver intelligent automation, predictive insights, and personalized experiences at scale.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {capabilities.map((capability, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:bg-white/20 transition-all group"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-yellow-400 to-pink-400 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${capability.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{capability.title}</h3>
              <p className="text-gray-200">{capability.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button className="px-8 py-4 bg-white text-indigo-600 rounded-xl hover:shadow-2xl transition-all font-semibold cursor-pointer whitespace-nowrap inline-flex items-center space-x-2">
            <span>Explore AI Features</span>
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
